import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import * as React from 'react';
import { FC } from 'react';
import { toggleButtonGroupStyle, toggleButtonStyle } from './ChartToggle.style';

type ChartToggleProps = {
  firstButtonName: string;
  secondButtonName: string;
  onChange: () => void;
};

const ChartToggle: FC<ChartToggleProps> = ({ firstButtonName, secondButtonName, onChange }) => {
  const [chartType, setChartType] = React.useState('bar');

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newChartType: string | null,
  ) => {
    if (newChartType !== null) {
      setChartType(newChartType);
      onChange();
    }
  };

  return (
    <ToggleButtonGroup
      value={ chartType }
      exclusive
      onChange={ handleChange }
      aria-label="Chart type"
      sx={ toggleButtonGroupStyle }
    >
      <ToggleButton value="bar" aria-label="bar chart" sx={ toggleButtonStyle }>
        { firstButtonName }
      </ToggleButton>
      <ToggleButton value="pie" aria-label="pie chart" sx={ toggleButtonStyle }>
        { secondButtonName }
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ChartToggle;
